module.exports = __webpack_public_path__ + "img/Rain.7423a2f9.svg";